import axios from 'axios';
import { baseUrl,baseUrl_SPB } from '../BaseUrl'



const AddBookedItem = async (bookedItem, token, url) => {
        // Ensure jobId is present on all items (endtime should be set by caller)
        const itemsWithJobId = Array.isArray(bookedItem)
            ? bookedItem.map(item => ({ ...item, jobId: item.jobId || (item.job && item.job.id) || undefined }))
            : [{ ...bookedItem, jobId: bookedItem.jobId || (bookedItem.job && bookedItem.job.id) || undefined }];
    try {
        // Call both endpoints
        const userPromise = axios.post(`${baseUrl_SPB}/api/v1/usertimeallocation/save`, itemsWithJobId, {
            headers: {
                'Authorization': 'Bearer ' + token
            },
        });
        
        // Wait for both to complete, return both results
        const [userResult] = await Promise.allSettled([userPromise]);
        if (userResult && userResult.status === 'fulfilled' && userResult.value && userResult.value.data) {
            return userResult.value.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error adding booked item:', error);
        return null;
    }
}


export default AddBookedItem;;